import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import account from './modules/account'
import setting from './modules/setting'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    homePage: '', // 首页地址
    spinning: false
  },
  mutations: {
    setSpinning (state, spinning) {
      state.spinning = spinning
    },
    setHomePage (state, homePage) {
      state.homePage = homePage
    }
  },
  actions: {

  },
  modules: {
    account,
    setting
  },
  plugins: [createPersistedState({ storage: window.sessionStorage })]
})
